<div class="high-impact-details">
  <nz-tabset
    [(nzSelectedIndex)]="activeTab"
    class="trs-tab-set">

    <!-- Tab 0: Impacted / Most Impacted Test Cases -->
    <nz-tab [nzTitle]="(type === 'most_impacted' ? 'Most Impacted Test Cases' : 'Impacted Test Cases') + ' (' + impactedTestCases.length + ')'">
      <app-zorro-table
        [columns]="tableColumns"
        [data]="impactedTestCases"
        (handleActions)="onTableAction($event)"
        (onRowSelect)="onTableAction($event)">
      </app-zorro-table>
    </nz-tab>

    <!-- Tab 1: Modified Code Files -->
    <nz-tab [nzTitle]="'Modified Code Files (' + modifiedFiles.length + ')'">
      <div *ngIf="loading" class="v-center" style="height: 500px;">
        <app-loading [text]="'Loading data..'" class="h-100"></app-loading>
      </div>

      <app-expandable-accordion
        [hidden]="loading"
        [data]="accordionData"
        [templateId]="'recommendations_table'"
        [showSelectAll]="false"
        [showRecommendations]="false"
        [hideRecommendationCount]="true"
        [makeTitleBold]="true"
        [hideCodeSnippetTitle]="true"
        (actionEmit)="onAccordionAction($event)">
      </app-expandable-accordion>
    </nz-tab>

  </nz-tabset>
</div>
